<template>
  <div>
    <slot></slot>
    <button class="button button--cta button--grid" @click="addItems" v-show="itemsCount < itemsTotal">
      Charger plus d'articles <strong>{{ itemsCount }} / {{ itemsTotal }}</strong>
    </button>
  </div>
</template>

<script>
import { computed, onMounted, ref, nextTick } from 'vue';

export default {
  props: {
    step: {
      type: Number,
      default: 6
    },
    start: {
      type: Number,
      default: 18
    }
  },
  setup(props){
  const items = ref([]);
  const itemsCount = ref(props.start);
  const addStep = ref(props.step);

  const itemsTotal = computed(() => items.length);

  function addItems() {
    itemsCount.value += addStep.value;
    if (itemsCount.value > itemsTotal.value) {
      itemsCount.value = itemsTotal.value;
    }
    displayItems();
  }

  function displayItems() {
    items.value.forEach((item, key) => {
      console.log("active", item)
      item.active = item.active || (!item.active && key < itemsCount.value);
    });
  }

  onMounted(async () => {
    await nextTick();
    displayItems();
  });

    return { addItems, itemsCount, itemsTotal };
  }

}


</script>
